import React from "react";
import { connect } from "react-redux";
import {
  selectors as localeSelectors,
  actions as localeActions
} from "../../../../redux/locale";
import { actions as storageActions } from "../../../../redux/storage";
import { Popover, List } from "@vitalsource/vstui/labs";
import { Button, Icon } from "@vitalsource/vstui";
import { Translation } from "../../../core/translate";

const Locales = ({ languages, currentLanguage, updateLocale }) => {
  return (
    <Popover
      content={
        <List
          data={[
            {
              listItems: languages.map(({ short, long, img }) => ({
                onClick: () => updateLocale(short),
                iconStart: (
                  <Icon height={16} width={16}>
                    <image
                      xlinkHref={img}
                      x="0"
                      y="0"
                      height="16px"
                      width="16px"
                    />
                  </Icon>
                ),
                text: long,
                selected: short === currentLanguage.short
              })),
              type: "radioGroup"
            }
          ]}
        />
      }
      modifiers={{
        offset: {
          offset: "0, 4px"
        }
      }}
    >
      <Button
        naked
        iconStart={
          <Icon height={16} width={16}>
            <image
              xlinkHref={currentLanguage.img}
              x="0"
              y="0"
              height="16px"
              width="16px"
            />
          </Icon>
        }
        color="neutral"
      >
        <Translation id="base.language">{currentLanguage.long}</Translation>
      </Button>
    </Popover>
  );
};

const mapStateToProps = state => ({
  languages: localeSelectors.getLanguages(state),
  currentLanguage: localeSelectors.getCurrentLanguage(state)
});

const mapDispatchToProps = dispatch => ({
  updateLocale: locale => {
    dispatch(localeActions.fetchLocale(locale));
    dispatch(
      storageActions.setKey("updateLanguageOnLogin", locale, {
        userScope: false
      })
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Locales);
